export default function SectionTitle({
  eyebrow,
  title,
  description,
  align = "left",
  chapter,
  className = "",
  testId,
}) {
  const alignCls =
    align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div
      data-testid={testId}
      className={`flex flex-col ${alignCls} gap-4 ${className}`}
    >
      {chapter && (
        <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-muted-foreground">
          <span className="text-brand-gradient font-semibold">{chapter}</span>
          <span className="opacity-40 mx-2">/</span>
          <span>{eyebrow}</span>
        </div>
      )}
      {!chapter && eyebrow && (
        <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-semibold text-muted-foreground">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand-gradient" />
          {eyebrow}
        </div>
      )}
      <h2 className="font-heading font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-[-0.03em] leading-[1.05] max-w-4xl">
        {title}
      </h2>
      {description && (
        <p className="text-base sm:text-lg text-muted-foreground max-w-2xl leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
